module.exports = __webpack_public_path__ + "static/images/index-gift-bg.a3f2ec6.png";